import { defineStore } from 'pinia';
import { courseClient } from 'iegsp-api/git.woa.com/itrpcprotocol/iegsp/suppliercgi/course/course.http';
import type { Student } from 'iegsp-api/git.woa.com/itrpcprotocol/iegsp/course/course/course';
import type {
  QueryUserInfoReq,
  QueryUserInfoRsp,
} from 'iegsp-api/git.woa.com/itrpcprotocol/iegsp/suppliercgi/course/course';

export enum UserType {
  Regular = 2,
}

export enum LoginStatus {
  unready = 0,
  success = 1,
  fail = 2,
}

// 用户信息
export interface UserInfo extends Student {
  /** 是否商务接口人 */
  is_white?: boolean;
}

// 用户待办
export interface UserTodo {
  /** 待办数量 */
  todo_count?: number;
  /** 已完成数量 */
  completed_count?: number;
  /** 待审核数量 */
  review_count?: number;
  /** 正在学习的课程ID */
  study_course_id?: number;
  /** 课程学习截止时间 */
  deadline?: string;
}

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: {} as UserInfo,
    userTodo: {} as UserTodo,
    loginStatus: LoginStatus.unready,
  }),
  actions: {
    getUserInfo(query?: QueryUserInfoReq) {
      return courseClient.QueryUserInfo({ only_student: false, ...query }).then(([res]) => {
        this.setUserInfo(res);
        this.setUserTodo(res);
        this.setLoginStatus(LoginStatus.success);
        return res;
      });
    },
    getUserTodo() {
      return courseClient.QueryUserInfo({}).then(([res]) => {
        this.setUserTodo(res);
        return res;
      });
    },
    setUserInfo(data: QueryUserInfoRsp) {
      this.userInfo = {
        ...data.student,
        is_white: data.is_white,
      };
    },
    setUserTodo(data: QueryUserInfoRsp) {
      this.userTodo = {
        todo_count: data.todo_count || 0,
        completed_count: data.completed_count || 0,
        review_count: data.review_count || 0,
        study_course_id: data.study_course_id,
        deadline: data.deadline,
      };
    },
    resetUserInfo() {
      this.userInfo = {};
      this.userTodo = {};
    },
    setLoginStatus(type: LoginStatus) {
      this.loginStatus = type;
    },
    logout() {
      return courseClient.LoginOut({}).then(() => {
        this.resetUserInfo();
        this.setLoginStatus(LoginStatus.unready);
      });
    },
  },
  getters: {
    isBusinessOrAdmin: (state) => state.userInfo.is_white,
    watermarkContent: (state) => `${state.userInfo.name || ''}${state.userInfo.phone || ''}`,
  },
});
